import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getValueBeforeTax',
})
export class GetValueBeforeTaxPipe implements PipeTransform {
  transform(value: any, rate: any): any {
    return value / (rate / 100 + 1);
  }
}
